module.exports = __webpack_public_path__ + "static/img/image_harvest_background.53f6383.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_harvest_background.png
// module id = 808
// module chunks = 1